import React from 'react';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import CommonTableHead from './CommonTableHead';

type Props = {
  tableHeads: Array<string>;
  tableBody: JSX.Element;
};

const CommonTableContainer: React.FC<Props> = ({ tableHeads, tableBody }) => {
  return (
    <TableContainer component={Paper}>
      <Table size="small">
        <CommonTableHead tableHeads={tableHeads} />
        {tableBody}
      </Table>
    </TableContainer>
  );
};
export default CommonTableContainer;
